module.exports = __webpack_public_path__ + "static/media/mbl_bg_blank_logo.290b835f.svg";